import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getOrderRelatedFilmForShowtime } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { OrderCartContextInstance } from '../types/context';
import { OrderCartTicketList } from './ticket-list';
const b = bemClassBuilder('v-order-cart-showtime');
export const OrderCartShowtime = observer(props => {
    const i18n = useI18n();
    const { tickets, showtimeId } = props.orderShowtime;
    const film = getOrderRelatedFilmForShowtime(showtimeId);
    const { config } = useContext(OrderCartContextInstance);
    if (!film) {
        throw new Error(`Failed to render OrderCartShowtime. Could not find film for showtime ${showtimeId}`);
    }
    return (_jsxs("li", Object.assign({ className: b.block() }, { children: [config.filmTitle.show && _jsx("span", Object.assign({ className: b.element('film-title') }, { children: i18n.translatable(film.title) })), config.tickets.show && _jsx(OrderCartTicketList, { orderTickets: tickets, showtimeId: showtimeId })] })));
});
OrderCartShowtime.displayName = 'OrderCartShowtime';
